import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { getDefaultLimitForRegion } from '../helpers/travel/travelCalcHelpers';

function useDefaultLimitSelection(
  region,
  selectedPlan,
  setSelectedLimit,
  selectedLimit,
  STATIC_PLANS,
) {
  useEffect(() => {
    if (region) {
      const defaultSelectedLimit = !isEmpty(selectedLimit)
        ? selectedLimit : getDefaultLimitForRegion(region);
      const limits = selectedPlan && STATIC_PLANS[selectedPlan].limits.map((limit) => limit.id);
      let limitToSelect = {};
      if (!!defaultSelectedLimit && !!limits && limits.includes(defaultSelectedLimit.id)) {
        limitToSelect = defaultSelectedLimit;
      } else if (selectedPlan) {
        // here we are checking again, if has default limit of region
        limitToSelect = getDefaultLimitForRegion(region) || STATIC_PLANS[selectedPlan].limits[0];
      }
      // eslint-disable-next-line no-unused-expressions
      !isEmpty(limitToSelect) && setSelectedLimit(limitToSelect);
    }
  }, [STATIC_PLANS, region, selectedLimit, selectedPlan, setSelectedLimit]);
}

export default useDefaultLimitSelection;
